import { withErrorBoundary } from 'app/components/error-boundary';
import type { NavigationScreen } from 'app/types/navigation';
import { LenderNextScreenBody } from './lender-next-screen-body';
import { useLenderNextScreen } from './use-lender-next-screen';

const LenderNextScreenComponent: NavigationScreen<'lenderNext'> = ({ navigation }) => {
  const screenState = useLenderNextScreen(navigation);

  return <LenderNextScreenBody {...screenState} />;
};

export const LenderNextScreen: NavigationScreen<'lenderNext'> = withErrorBoundary(LenderNextScreenComponent);
